import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'millisecondsToSeconds',
  standalone: false,
})
export class MillisecondsToSeconds implements PipeTransform {
  constructor() {}
  transform(ms: number) {
    if (ms) {
      return (ms / 1000).toFixed(2) + 's';
    }
  }
}
